import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=8e9aba78&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=8e9aba78&prod&lang=scss"
import style1 from "./ProductList.vue?vue&type=style&index=1&id=8e9aba78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9aba78",
  null
  
)

export default component.exports